var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignupLayoutBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1627,
    height: 794,
    viewBox: "0 0 1627 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14722)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 1802,
    transform: "translate(-5 -459)",
    fill: "url(#paint0_linear_1_14722)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1119.56 -410.448C1399.26 -196.635 1482.12 227 1149.55 438.906C863.012 621.478 955.245 994.722 2274.34 786.277C2465.04 761.307 3245.69 648.65 2078.9 712.096C2078.9 712.096 1012.47 790.464 1403.61 485.739C2366.97 -214.074 2291.51 -683.46 1774.34 -768.474C1233.89 -857.342 435.961 -932.997 1119.56 -410.448Z",
    fill: "url(#paint1_linear_1_14722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.572 900.252C-370.964 1182.37 -1138.65 959.397 -1849.56 724.084C-2496.87 509.828 -3186.95 914.947 -2380.18 1532.78L444.369 1532.78C1065.38 937.828 955.337 459.389 146.572 900.252Z",
    fill: "url(#paint2_linear_1_14722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-645.053 -1219.95C-923.717 -1345.44 -1331.75 -1317.59 -1047.69 -516.193C-662.364 570.98 806.823 307.008 859.016 80.6999C951.949 -322.262 -442.419 -356.972 -228.977 -673.374C-65.0425 -1009.76 -342.764 -1083.91 -645.053 -1219.95Z",
    fill: "url(#paint3_linear_1_14722)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14722",
    x1: -131,
    y1: 1440.5,
    x2: 1432.12,
    y2: 1310.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_14722",
    x1: 1515.71,
    y1: -395.653,
    x2: 1232.33,
    y2: 856.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_14722",
    x1: -1586.06,
    y1: 1823.04,
    x2: -1540.82,
    y2: 576.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_14722",
    x1: 480.803,
    y1: 751.127,
    x2: -76.0932,
    y2: -337.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1632,
    height: 1802,
    fill: "white",
    transform: "translate(-5 -459)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignupLayoutBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYyNyIgaGVpZ2h0PSI3OTQiIHZpZXdCb3g9IjAgMCAxNjI3IDc5NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTQ3MjIpIj4KPHJlY3Qgd2lkdGg9IjE2MzIiIGhlaWdodD0iMTgwMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUgLTQ1OSkiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xXzE0NzIyKSIvPgo8ZyBvcGFjaXR5PSIwLjIiPgo8cGF0aCBkPSJNMTExOS41NiAtNDEwLjQ0OEMxMzk5LjI2IC0xOTYuNjM1IDE0ODIuMTIgMjI3IDExNDkuNTUgNDM4LjkwNkM4NjMuMDEyIDYyMS40NzggOTU1LjI0NSA5OTQuNzIyIDIyNzQuMzQgNzg2LjI3N0MyNDY1LjA0IDc2MS4zMDcgMzI0NS42OSA2NDguNjUgMjA3OC45IDcxMi4wOTZDMjA3OC45IDcxMi4wOTYgMTAxMi40NyA3OTAuNDY0IDE0MDMuNjEgNDg1LjczOUMyMzY2Ljk3IC0yMTQuMDc0IDIyOTEuNTEgLTY4My40NiAxNzc0LjM0IC03NjguNDc0QzEyMzMuODkgLTg1Ny4zNDIgNDM1Ljk2MSAtOTMyLjk5NyAxMTE5LjU2IC00MTAuNDQ4WiIgZmlsbD0idXJsKCNwYWludDFfbGluZWFyXzFfMTQ3MjIpIi8+CjxwYXRoIGQ9Ik0xNDYuNTcyIDkwMC4yNTJDLTM3MC45NjQgMTE4Mi4zNyAtMTEzOC42NSA5NTkuMzk3IC0xODQ5LjU2IDcyNC4wODRDLTI0OTYuODcgNTA5LjgyOCAtMzE4Ni45NSA5MTQuOTQ3IC0yMzgwLjE4IDE1MzIuNzhMNDQ0LjM2OSAxNTMyLjc4QzEwNjUuMzggOTM3LjgyOCA5NTUuMzM3IDQ1OS4zODkgMTQ2LjU3MiA5MDAuMjUyWiIgZmlsbD0idXJsKCNwYWludDJfbGluZWFyXzFfMTQ3MjIpIi8+CjxwYXRoIGQ9Ik0tNjQ1LjA1MyAtMTIxOS45NUMtOTIzLjcxNyAtMTM0NS40NCAtMTMzMS43NSAtMTMxNy41OSAtMTA0Ny42OSAtNTE2LjE5M0MtNjYyLjM2NCA1NzAuOTggODA2LjgyMyAzMDcuMDA4IDg1OS4wMTYgODAuNjk5OUM5NTEuOTQ5IC0zMjIuMjYyIC00NDIuNDE5IC0zNTYuOTcyIC0yMjguOTc3IC02NzMuMzc0Qy02NS4wNDI1IC0xMDA5Ljc2IC0zNDIuNzY0IC0xMDgzLjkxIC02NDUuMDUzIC0xMjE5Ljk1WiIgZmlsbD0idXJsKCNwYWludDNfbGluZWFyXzFfMTQ3MjIpIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzFfMTQ3MjIiIHgxPSItMTMxIiB5MT0iMTQ0MC41IiB4Mj0iMTQzMi4xMiIgeTI9IjEzMTAuMjkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzBCRTFGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDY5RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDFfbGluZWFyXzFfMTQ3MjIiIHgxPSIxNTE1LjcxIiB5MT0iLTM5NS42NTMiIHgyPSIxMjMyLjMzIiB5Mj0iODU2LjE0NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQzZFM0ZGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0M2RTNGRiIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl8xXzE0NzIyIiB4MT0iLTE1ODYuMDYiIHkxPSIxODIzLjA0IiB4Mj0iLTE1NDAuODIiIHkyPSI1NzYuMTc5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNDNkUzRkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQzZFM0ZGIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDNfbGluZWFyXzFfMTQ3MjIiIHgxPSI0ODAuODAzIiB5MT0iNzUxLjEyNyIgeDI9Ii03Ni4wOTMyIiB5Mj0iLTMzNy44MDIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0M2RTNGRiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNDNkUzRkYiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTQ3MjIiPgo8cmVjdCB3aWR0aD0iMTYzMiIgaGVpZ2h0PSIxODAyIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUgLTQ1OSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";